import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PharmacyManagementSystemIntegrationStepsEnum} from '../../../../interfaces/PharmacyManagementSystemIntegrationStepsEnum';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AlertTypesEnum} from '../../../../../shared/interfaces/AlertTypesEnum';
import {Select} from '@ngxs/store';
import {ProfileState} from '../../../../../shared/states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';
// eslint-disable-next-line max-len
import {IAlertMessage} from '../../../../../shared/interfaces/alert-message.interface';
import { IIntegrationConfiguration, IntegrationTypeEnum } from 'src/app/shared/interfaces/integration.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';

@UntilDestroy()
@Component({
  selector: 'app-pms-select-type',
  templateUrl: './pms-select-type.component.html',
  styleUrls: ['./pms-select-type.component.scss'],
})
export class PmsSelectTypeComponent implements OnInit {
  @Input() progress: PharmacyManagementSystemIntegrationStepsEnum;
  @Input() selectedType: IntegrationTypeEnum; 
  @Output() integrationTypeSelected: EventEmitter<IntegrationTypeEnum> = new EventEmitter<IntegrationTypeEnum>();
  @Output() cancel: EventEmitter<PharmacyManagementSystemIntegrationStepsEnum> = new EventEmitter();
  @Output() next: EventEmitter<PharmacyManagementSystemIntegrationStepsEnum> = new EventEmitter();

  connectionForm: UntypedFormGroup;

  PharmacyManagementSystemIntegrationStepsEnum = PharmacyManagementSystemIntegrationStepsEnum;
  IntegrationTypeEnum = IntegrationTypeEnum;

  public integrationTypes: Array<{id: number, name: string}>;

  alertMessage: IAlertMessage;
  autohideDelay = 3;
  showMessage: boolean;
  AlertTypesEnum = AlertTypesEnum;

  @Select(ProfileState.loading) loading$: Observable<boolean | undefined>;
  @Select(ProfileState.success) success$: Observable<boolean | undefined>;
  @Select(PharmacyState.currentPharmacy) currentPharmacy$: Observable<any>;

  @ViewChild('apiKey') apiKey;
  @ViewChild('testConnectionButton') testConnectionButton;

  constructor(
    private fb: UntypedFormBuilder
  ) {
    this.integrationTypes = Object.keys(IntegrationTypeEnum)
      .filter(e => !Number.isNaN(Number.parseInt(e, 10)))
      .map(e => {
        return {id: Number.parseInt(e, 10), name: IntegrationTypeEnum[e].toString()};
      });
  }

  ngOnInit(): void {
    this.connectionForm = this.fb.group({
      integrationType: [this.selectedType, Validators.required],
      isActive: [true],
    });

    this.connectionForm.controls.integrationType.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((value: number) => {
        this.integrationTypeSelected.next(value);
      });
  }

  focusDropdown(name: string): void {
    setTimeout(() => {
      this[name].showDropdown = true;
      setTimeout(() => this[name].dropdownItemsQueryList?.toArray()[0]?.nativeElement.focus());
    });
  }

  focusButton(buttonName: string): void {
    setTimeout(() => this[buttonName]?.focus());
  }
}
